var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 505 505",
    style: {
      enableBackground: "new 0 0 505 505"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD05B"
    },
    cx: 252.5,
    cy: 252.5,
    r: 252.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.2,
    y: 141.3,
    style: {
      fill: "#FFFFFF"
    },
    width: 270.4,
    height: 239.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M162.6,116.2c-3.9,0-7,3.1-7,7v40.2c0,3.9,3.1,7,7,7s7-3.1,7-7v-40.2 C169.6,119.3,166.5,116.2,162.6,116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M243.4,116.2c-3.9,0-7,3.1-7,7v40.2c0,3.9,3.1,7,7,7s7-3.1,7-7v-40.2 C250.5,119.3,247.3,116.2,243.4,116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M324.3,116.2c-3.9,0-7,3.1-7,7v40.2c0,3.9,3.1,7,7,7s7-3.1,7-7v-40.2 C331.3,119.3,328.2,116.2,324.3,116.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136.7,
    y: 195.1,
    style: {
      fill: "#CED5E0"
    },
    width: 213.5,
    height: 16.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.7,
    y: 254.9,
    style: {
      fill: "#CED5E0"
    },
    width: 213.5,
    height: 16.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.7,
    y: 314.8,
    style: {
      fill: "#CED5E0"
    },
    width: 213.5,
    height: 16.1
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M366.9,280.9c-0.8-0.8-1.3-1.9-1.3-3.2c0.1-6.2,4.1-12.3,10.7-16.4c3.1-1.9,6.3-3.2,9.4-4.4 c1.8-0.7,3.7-1.5,5.5-2.3c9.4-4.6,17-13.2,20.4-23.1c1.8-5.2,2.4-10.7,3.2-16.5c0.5-3.7,0.9-7.5,1.7-11.2c0.5-2.4,2.8-3.9,5.2-3.4 c2.4,0.5,3.9,2.8,3.4,5.2c-0.7,3.4-1.1,6.9-1.6,10.6c-0.8,6-1.5,12.2-3.6,18.2c-4.2,12.3-13.2,22.6-24.9,28.2c-2,1-4,1.8-6.1,2.6 c-2.9,1.2-5.6,2.3-8.1,3.7c-3.1,1.9-6.4,5.2-6.4,8.9c0,2.4-2,4.4-4.5,4.4C368.8,282.2,367.7,281.7,366.9,280.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M260.6,345.1c-0.9-0.9-2.4-0.9-3.3,0l-13.1,13.1c-0.9,0.9-0.9,2.4,0,3.3s2.4,0.9,3.3,0l13.1-13.1 C261.5,347.5,261.5,346,260.6,345.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M417,162.8l-1.6-1.6L311.7,264.9l29.1,29.1l76.2-76.2C432.1,202.6,432.1,178,417,162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CDBC4"
    },
    d: "M311.7,264.9l-59,83c-2.3,3.3,1.7,7.3,5,5l83-59L311.7,264.9z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.895b92ce.svg";
export { ForwardRef as ReactComponent };